import React, { PureComponent } from 'react';
import { get } from 'lodash/fp';

import { connect } from 'react-redux';
import * as actions from 'actions/pathBuilder';
import Tooltip from 'components/shared/Tooltip';
import withModifiers from 'utils/add_modifiers';
import ConfirmationModal from './ConfirmationModal';

class UpdatePathButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmationModal: false,
      completedCount: null,
    };
    this.handleUpdatePath = this.handleUpdatePath.bind(this);
    this.cancelUpdatePath = this.cancelUpdatePath.bind(this);
  }

  handleUpdatePath(options) {
    if (this.props.loading) return;
    this.props
      .updatePath({ merge: options })
      .then(({ success, completedUsersCount: completedCount }) => {
        if (this.buttonRef) {
          this.setState({
            showConfirmationModal: !success,
            completedCount: success ? null : completedCount,
          });
        }
      });
  }

  cancelUpdatePath() {
    this.setState({ showConfirmationModal: false });
  }

  render() {
    const { hasUnsavedChanges, loading, isCertification } = this.props;
    const { showConfirmationModal } = this.state;

    return (
      <div
        className="d-ib"
        ref={n => {
          this.buttonRef = n;
        }}
      >
        <Tooltip text={hasUnsavedChanges.reason && hasUnsavedChanges.reason}>
          <button
            type="button"
            className={withModifiers('NewButton', ['tallAndWide', 'yellow'])}
            onClick={() => this.handleUpdatePath()}
            disabled={!hasUnsavedChanges.value}
          >
            {loading && <span className="Spinner mr-8" />}
            {!isCertification && t('paths.path_builder.button_update_path')}
            {isCertification &&
              t(
                'certifications.certification_builder.button_update_certification',
              )}
          </button>
        </Tooltip>
        {showConfirmationModal && (
          <ConfirmationModal
            updateInProgress={this.props.loading}
            completedCount={this.state.completedCount}
            onSubmit={options => this.handleUpdatePath(options)}
            onCancel={this.cancelUpdatePath}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  loading: pathBuilder.updateInProgress,
  isCertification: !!get('certification')(pathBuilder),
});

const mapDispatchToProps = {
  updatePath: actions.saveDraft,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePathButton);
